module.exports = "/build/admin/images/placeholder.f8ef63a9.png";